import {
    // messages
    REQUEST_MESSAGES_COUNTER,
    SET_MESSAGES_COUNTER,
    REQUEST_MESSAGES_RANGE,
    SET_MESSAGES_RANGE,
    // users
    REQUEST_USERS_COUNTER,
    SET_USERS_COUNTER,
    REQUEST_USERS_RANGE,
    SET_USERS_RANGE,
    // CONCURRENT_CONNECTIONS
    REQUEST_CONNECTIONS_COUNTER,
    REQUEST_CONNECTIONS_RANGE,
    SET_CONNECTIONS_COUNTER,
    SET_CONNECTIONS_RANGE
} from './constants'

const initialState = {
    messagesCounter: {},
    messagesRange: {},
    loadingMessagesCounter: true,
    loadingMessagesRange: true,

    usersCounter: {},
    usersRange: {},
    loadingUsersCounter: true,
    loadingUsersRange: true,

    loadingConnectionsCounter: true,
    loadingConnectionsRange: true,
    connectionsCounter: {},
    connectionsRange: {}
}

const reducer = (state = initialState, { type, payload, error }) => {
    switch (type) {
        //
        // Messages
        //
        case REQUEST_MESSAGES_COUNTER:
            return {
                ...state,
                loadingMessagesCounter: true
            }
        case REQUEST_MESSAGES_RANGE:
            return {
                ...state,
                loadingMessagesRange: true
            }
        case SET_MESSAGES_COUNTER:
            return {
                ...state,
                messagesCounter: payload.messagesCounter,
                loadingMessagesCounter: false
            }
        case SET_MESSAGES_RANGE:
            return {
                ...state,
                messagesRange: payload.messagesRange,
                loadingMessagesRange: false
            }
        //
        // Users
        //
        case REQUEST_USERS_COUNTER:
            return {
                ...state,
                loadingUsersCounter: true
            }
        case REQUEST_USERS_RANGE:
            return {
                ...state,
                loadingUsersRange: true
            }
        case SET_USERS_COUNTER:
            return {
                ...state,
                usersCounter: payload.usersCounter,
                loadingUsersCounter: false
            }
        case SET_USERS_RANGE:
            return {
                ...state,
                usersRange: payload.usersRange,
                loadingUsersRange: false
            }

        //
        // Connections
        //
        case REQUEST_CONNECTIONS_COUNTER:
            return {
                ...state,
                loadingConnectionsCounter: true
            }
        case REQUEST_CONNECTIONS_RANGE:
            return {
                ...state,
                loadingConnectionsRange: true
            }
        case SET_CONNECTIONS_COUNTER:
            return {
                ...state,
                connectionsCounter: payload.connectionsCounter,
                loadingConnectionsCounter: false
            }
        case SET_CONNECTIONS_RANGE:
            return {
                ...state,
                connectionsRange: payload.connectionsRange,
                loadingConnectionsRange: false
            }

        // case SET_CURRENT_CONNECTIONS:
        //     return {
        //         ...state,
        //         currentConnections: payload.currentConnections
        //     }
        // default:
        //     return state
        default:
            return state
    }
}

export default reducer
